function getCookie(c_name) {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}
$(document).ready(function(){  
    var acookie = getCookie("swatchlogin");
	if(!acookie) {
      $("#login-form-cs").show();
      $("#loged-el").hide();     
    }
	else {
		$("#login-form-cs").hide();
		$("#loged-el").show();                                            
	}  

/*Current Date*/  
      var currentDate = new Date();
    
      // Extract the date components (year, month, day)
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth() + 1; // Note: Months are zero-based, so add 1
      var day = currentDate.getDate();
    
      // Display the date
      $(".cur-date").text("Date: " + month + "/" + day + "/" + year);   
/*Current Date*/    
  
  function ValidateEmail(email){
  	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  	return re.test(email);
  }
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }  
  $(".btn--full.login").click(function(){
    $(".erate-cs .errors").hide();
    $(".required-field").hide();
    
    var email = $('#loginusername').val();
    var password = $('#loginpassword').val();
    var error = false;       
	
	//email
	if(email == ""){
		$(".erate-cs .required-field.email").show();
		error = true;
	}
	else{
		if(!ValidateEmail(email)){
			$(".erate-cs .required-field.email").hide();
			$(".erate-cs .required-field.check-email").show();
			error = true;
		}else{
		    $(".erate-cs .required-field.email").hide();
			$(".erate-cs .required-field.check-email").hide();
		}
	}
	
	if(password == ""){
		$(".erate-cs .required-field.password").show();
		error = true;
	}	
	
	if(error == false){
                 if( $("#loginusername").val()=='nydesignerfabrics@gmail.com' && $("#loginpassword").val()=='@NYdf156') {
                         $(".erate-cs .errors").hide();
                         $("#login-form-cs").hide();
                         $("#loged-el").show();      
                         setCookie("swatchlogin", "true", 1);
                     }
                 else {
                     $(".erate-cs .errors").show();
                 }
	}	                 

         });

  jQuery('.btn--full.generate-swa').click(function(){
  		$(".erate-cs .required-field.order").hide();
      	var ordersw = $('#swatch_gen').val();
      	var error = false;


  	//orderempty
  	if(ordersw == ""){
  		$(".erate-cs .required-field.order").show();
  		error = true;
  	}
    	
    	if(!error){
          var mydata = {order_id:ordersw};
          	jQuery('.erate-cs').addClass('loading');
        	jQuery.ajax({
        		type: "POST",
        		url: 'https://9b39e9cd9a.nxcli.io/swatch-generate.php',
        		dataType: 'json',
              	contentType: 'application/json',
              	data: JSON.stringify(mydata), 
        	  	success: function(data){
                  if(data.success == 0){
                    jQuery('#order_messages').html(data.message);
                    jQuery('#print-generated').hide();
                  }else{
                  	jQuery('#order_messages').html('');
                    jQuery('#my-to-content').html(data.message);
                    jQuery('#print-generated').show();
                    jQuery('div#track_order .heading img').addClass('active');
                  }
                  jQuery('.erate-cs').removeClass('loading');
        		}
        	});
         
        }
  });


  $("#print-doc").click(function() {    
    var oTable = document.getElementById("print-element");
    var newWindow = window.open('', '_blank'); // Open a new window

    // Append the div's content to the new window
    newWindow.document.open();
    newWindow.document.write('<html><head><style>.header-print-gen{display: none;}#my-to-content{display: none;}@media print {table#print-element {width: 100%;display: table !Important;}.header-print-gen {width: 100%;text-align: center;margin-bottom:55px;}.product-items .swatch-item{display: block;font-size: 17px;margin:90px 0px 90px 0px;break-inside: avoid;}.swatch-item p{font-size:17px;line-height: 60%;margin-bottom: 0px !important;}.swatch-item p span{font-weight: 600;margin-right: 5px;}.swatch-item p .value{text-decoration: underline;}.header-print-gen p{font-size: 14px;margin: 0px;}.product-items .cs-Product {display:none !Important;}.header-print-gen p.cur-date {position: absolute;right: 0px;bottom: 10px;}.header-print-gen {position: relative;}.header-print-gen{display: block;}#my-to-content{display: block;}.product-items .swatch-item:nth-child(1) {margin-top: 45px;}}</style></head><title>NYDF Swatch Print</title>');
    newWindow.document.write('</head><body><center>');
    newWindow.document.write(oTable.parentNode.innerHTML);
    newWindow.document.close();
    
    newWindow.print();
    newWindow.close();
  });
  
  
});